import styles from "./styles.module.css";
import starIcon from "../../../assets/icons/Star.svg";
import cx from "classnames";
import { ProtectedImage } from "src/components/atoms/ProtectedImage";

type User = {
    id: number;
    name: string;
    email: string;
    avatarUrl: string;
    isFeatured?: boolean
};

type UserAvatarProps = {
    user: User | null;
    isStar?: boolean;
    isColumn?: boolean;
    size?: "default" | "compact";
};

const AVATAR_COLORS = [
    "#146EF4", "#7C3AED", "#059669", "#DC2626",
    "#D97706", "#0891B2", "#BE185D", "#4F46E5",
];

function getInitials(name: string): string {
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.slice(0, 2).toUpperCase();
}

function getAvatarColor(name: string): string {
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
    user,
    isStar = true,
    isColumn,
    size = "default",
}) => {
    const isCompact = size === "compact";

    return (
        <div className={cx(styles.wrapperFlex, {
                    [styles.wrapperFlexrColumn]: isColumn,
                    [styles.wrapperFlexCompact]: isCompact,
                })}>
            <div className={styles.containerUserAvatar}>
                {isStar && user?.isFeatured &&
                    (<div className={styles.star}>
                        <img src={starIcon} alt="star" />
                    </div>)}
                <div className={cx(styles.avatar, {
                    [styles.avatarBig]: isColumn,
                    [styles.avatarCompact]: isCompact,
                })}>
                    <ProtectedImage
                        src={user?.avatarUrl}
                        alt={`${user?.name ?? "User"} avatar`}
                        loading="lazy"
                        fallback={user?.name ? (
                        <div
                            className={cx(styles.avatarInitials, {
                                [styles.avatarInitialsCompact]: isCompact,
                            })}
                            style={{ backgroundColor: getAvatarColor(user.name) }}
                        >
                            {getInitials(user.name)}
                        </div>
                        ) : null}
                    />
                </div>
            </div>
            <div className={cx(styles.dataUser, {
                [styles.dataUserCompact]: isCompact,
            })}>
                <p className={cx(styles.dataUserName, {
                    [styles.dataUserNameLarge]: isColumn
                })}>{user?.name}</p>
                <p className={styles.dataUserMail}>{user?.email}</p>
            </div>
        </div>)
};
